import {ResponsiveLine} from '@nivo/line'


export const LineGraph = ({data, xName, yName, height, xMin, xMax, yMin, yMax, funPointLabel}) => {

    console.log(data)

    return (




    <div style={{minHeight: height, height: height}} className={"w-100"}>

        <ResponsiveLine
            colors={{scheme: "set3"}}
            data={data}
            margin={{top: 50, right: 110, bottom: 50, left: 60}}

            xScale={{type: 'linear', min:xMin, max:xMax}}
            yScale={{
                type: 'linear',
                min: yMin,
                max: yMax,
                stacked: true,
                reverse: false
            }}

            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: xName,
                legendOffset: 36,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: yName,
                legendOffset: -40,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            pointSize={10}
            pointColor={{theme: 'background'}}
            pointBorderWidth={2}
            pointBorderColor={{from: 'serieColor'}}
            //pointLabel="data.id"
            pointLabel={({x, y, data}) => data.id }

            pointLabelYOffset={-12}
            enableTouchCrosshair={true}
            useMesh={true}
            enablePointLabel={true}
            animate={true}

        />
    </div>
)}